import React from 'react';
import { ITooltip, Tooltip } from 'react-tooltip-5';

import { getTailWindColors } from '@/utils/common';

const tailwindColors = getTailWindColors();
const grayEighty = tailwindColors.gray[80];

type Props = ITooltip & {
  /** Providing a children react node will set this as the content of the tooltip */
  id: string;
  maxWidth?: number;
};

/**
 * A generic use tooltip that is designed according to out new design system
 * [Figma](https://www.figma.com/file/Vd7dvy5BLNcY5pDkQ2j0dj/Unified-Design-System-(Working)?type=design&node-id=392-5451&t=1tfDe8n3T20uOh3z-4)
 */
const AcresToolTip: React.FC<Props> = ({
  id,
  maxWidth = undefined,
  ...props
}: Props) => {
  return (
    <Tooltip
      {...props}
      id={id}
      style={{
        backgroundColor: grayEighty,
        borderRadius: 0,
        color: tailwindColors.white.DEFAULT,
        maxWidth: maxWidth === undefined ? 280 : maxWidth,
        opacity: 100,
        zIndex: 1000,
      }}
    />
  );
};

export default AcresToolTip;
